const DEVICE_SERVICE_TYPE_TECHNICAL_SUPPORT =
  "DEVICE_SERVICE_TYPE_TECHNICAL_SUPPORT";
const DEVICE_SERVICE_TYPE_INSTALLATION = "DEVICE_SERVICE_TYPE_INSTALLATION";
const DEVICE_SERVICE_TYPE_MAINTENANCE = "DEVICE_SERVICE_TYPE_MAINTENANCE";

const DEVICE_SERVICE_TYPES = {
  TECHNICAL_SUPPORT: DEVICE_SERVICE_TYPE_TECHNICAL_SUPPORT,
  INSTALLATION: DEVICE_SERVICE_TYPE_INSTALLATION,
  MAINTENANCE: DEVICE_SERVICE_TYPE_MAINTENANCE
};

const DEVICE_SERVICE_TYPE_LABELS = {
  [DEVICE_SERVICE_TYPE_TECHNICAL_SUPPORT]:
    "device.service.type.technical.support",
  [DEVICE_SERVICE_TYPE_INSTALLATION]: "device.service.type.installation",
  [DEVICE_SERVICE_TYPE_MAINTENANCE]: "device.service.type.maintenance"
};

const DEVICE_SERVICE_SEVERITY_GENERAL = "DEVICE_SERVICE_SEVERITY_GENERAL";
const DEVICE_SERVICE_SEVERITY_HIGH = "DEVICE_SERVICE_SEVERITY_HIGH";
const DEVICE_SERVICE_SEVERITY_VERY_HIGH = "DEVICE_SERVICE_SEVERITY_VERY_HIGH";
const DEVICE_SERVICE_SEVERITY_LOW = "DEVICE_SERVICE_SEVERITY_LOW";

const DEVICE_SERVICE_SEVERITIES = {
  GENERAL: DEVICE_SERVICE_SEVERITY_GENERAL,
  HIGH: DEVICE_SERVICE_SEVERITY_HIGH,
  VERY_HIGH: DEVICE_SERVICE_SEVERITY_VERY_HIGH,
  LOW: DEVICE_SERVICE_SEVERITY_LOW
};

const DEVICE_SERVICE_SEVERITY_LABELS = {
  [DEVICE_SERVICE_SEVERITY_GENERAL]: "device.service.severity.general",
  [DEVICE_SERVICE_SEVERITY_HIGH]: "device.service.severity.high",
  [DEVICE_SERVICE_SEVERITY_VERY_HIGH]: "device.service.severity.very.high",
  [DEVICE_SERVICE_SEVERITY_LOW]: "device.service.severity.low"
};

const DEVICE_SERVICE_STATUS_UNASSIGNED = "DEVICE_SERVICE_STATUS_UNASSIGNED";
const DEVICE_SERVICE_STATUS_PENDING_SUPPORT_REPLY =
  "DEVICE_SERVICE_STATUS_PENDING_SUPPORT_REPLY";
const DEVICE_SERVICE_STATUS_PENDING_USER_REPLY =
  "DEVICE_SERVICE_STATUS_PENDING_USER_REPLY";
const DEVICE_SERVICE_STATUS_RESOLVED = "DEVICE_SERVICE_STATUS_RESOLVED";
// For device showing
const DEVICE_SERVICE_STATUS_NO_REQUEST = "DEVICE_SERVICE_STATUS_NO_REQUEST";
const DEVICE_SERVICE_STATUS_NONE = "DEVICE_SERVICE_STATUS_NONE";

const DEVICE_SERVICE_STATUES = {
  UNASSIGNED: DEVICE_SERVICE_STATUS_UNASSIGNED,
  PENDING_SUPPORT_REPLY: DEVICE_SERVICE_STATUS_PENDING_SUPPORT_REPLY,
  PENDING_USER_REPLY: DEVICE_SERVICE_STATUS_PENDING_USER_REPLY,
  RESOLVED: DEVICE_SERVICE_STATUS_RESOLVED,
  NO_REQUEST: DEVICE_SERVICE_STATUS_NO_REQUEST,
  NONE: DEVICE_SERVICE_STATUS_NONE
};

const DEVICE_SERVICE_STATUS_LABELS = {
  [DEVICE_SERVICE_STATUS_UNASSIGNED]: "device.service.status.unassigned",
  [DEVICE_SERVICE_STATUS_PENDING_SUPPORT_REPLY]:
    "device.service.status.pending.support.reply",
  [DEVICE_SERVICE_STATUS_PENDING_USER_REPLY]:
    "device.service.status.pending.user.reply",
  [DEVICE_SERVICE_STATUS_RESOLVED]: "device.service.status.resolved",
  [DEVICE_SERVICE_STATUS_NO_REQUEST]: "device.service.status.noRequest",
  [DEVICE_SERVICE_STATUS_NONE]: "device.service.status.none"
};

export {
  DEVICE_SERVICE_TYPES,
  DEVICE_SERVICE_TYPE_LABELS,
  DEVICE_SERVICE_SEVERITIES,
  DEVICE_SERVICE_SEVERITY_LABELS,
  DEVICE_SERVICE_STATUES,
  DEVICE_SERVICE_STATUS_LABELS
};
